import React from 'react';

import styled, { css } from 'styled-components';

import Localized, { Strings } from 'utils/localize';

export interface CheckboxProps {
  isActive: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

function Checkbox({ isActive, disabled, onClick }: CheckboxProps) {
  return (
    <Wrapper onClick={onClick} disabled={disabled}>
      <input type="checkbox" checked={isActive} onChange={() => {}} />
      <Slider>
        <Option isActive={!isActive}>{Localized(Strings.checkbox.off)}</Option>
        <Option isActive={isActive}>{Localized(Strings.checkbox.on)}</Option>
      </Slider>
      <Selector isActive={isActive} />
    </Wrapper>
  );
}

export default Checkbox;

const Wrapper = styled.div<{ disabled?: boolean }>`
  position: relative;

  flex-shrink: 0;
  box-sizing: border-box;
  width: 225px;
  height: 44px;
  margin: 0;
  padding: 3px;

  vertical-align: middle;

  border: solid 1px ${({ theme }) => theme.colors.blackHaze};
  border-radius: 4px;
  cursor: pointer;

  > input {
    display: none;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `};
`;

const Slider = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

const Option = styled.div<{ isActive: boolean }>`
  flex: 1;

  color: ${({ theme }) => theme.colors.white};
  font-size: 18px;
  text-align: center;

  transition: 0.2s;

  ${({ isActive, theme }) =>
    !isActive &&
    css`
      color: ${theme.colors.mirage};
      opacity: 0.3;
    `}
`;

const Selector = styled.div<{ isActive: boolean }>`
  width: 50%;
  height: 100%;

  background-color: ${({ theme }) => theme.colors.robinsEggBlue};

  border-radius: 4px;

  transition: 0.4s;

  ${({ isActive }) =>
    isActive &&
    css`
      transform: translateX(100%);
    `}
`;
